// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"18ddd079","787":"07deecf0"}[chunkId] + ".chunk.js";
};